import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import Type from '@nerdwallet/react-typography';
import Button from '@nerdwallet/react-button';

const ImageHero = ({
  backgroundClassName,
  preheader,
  title,
  body,
  bodyMobile,
  buttonText,
  buttonLink,
  opacityLevel,
}) => {
  const heroContainerClass = `image-hero__cont ${backgroundClassName}`;
  const innerOpacity = {
    backgroundColor: `rgba(255, 255, 255, ${opacityLevel})`,
  };

  return (
    <div className={heroContainerClass}>
      {title && (
        <div
          className={classNames([
            'image-hero__inner-cont',
            classes('margin-all-auto'),
            classes('padding-all-4'),
            classes('text-align-center'),
            classes('display-flex'),
            classes('display-block--wide'),
            classes('flex-direction-column'),
            classes('justify-content-center'),
            classes('width-100'),
            classes('height-100'),
            classes('width-auto--wide'),
          ])}
          style={innerOpacity}
        >
          {preheader && (
            <Type
              size="1"
              gotham
              bold
              uppercase
              className={classNames([
                'image-hero__hdr',
                classes('margin-bottom-3'),
              ])}
            >
              {preheader}
            </Type>
          )}
          {title && (
            <Type
              size="4"
              chronicle
              className={classNames([
                'image-hero__title',
                classes('margin-horizontal-auto'),
                classes('margin-bottom-3'),
              ])}
            >
              {title}
            </Type>
          )}
          {body && (
            <div>
              <Type
                size="2"
                gotham
                className={classNames([
                  'image-hero__body',
                  classes('display-none--wide'),
                ])}
              >
                {bodyMobile}
              </Type>
              <Type
                size="2"
                gotham
                className={classNames([
                  'image-hero__body',
                  classes('display-none'),
                  classes('display-block--wide'),
                ])}
              >
                {body}
              </Type>
            </div>
          )}
          {buttonText && (
            <div>
              <Button primary className="hero__btn" href={buttonLink}>
                {buttonText}
              </Button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

ImageHero.propTypes = {
  backgroundClassName: PropTypes.string,
  preheader: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string,
  bodyMobile: PropTypes.string,
  buttonText: PropTypes.string,
  buttonLink: PropTypes.string,
  opacityLevel: PropTypes.number,
};

ImageHero.defaultProps = {
  opacityLevel: 0.6,
};

ImageHero.displayName = 'Company Hero';

export default ImageHero;
